import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart } from '@angular/router';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { PaymentreceiptService } from '../../../../_services/paymentreceipt/paymentreceipt.service';
import { utilityService } from '../../../../sharedcomponents/commonservice/utility.service';
import { AppSettings, PaymentType, enumStatusCodeList } from '../../../../sharedcomponents/_common/constants/app.constants';

import { SendMoneyService } from '../../../../_services/sendmoneyservice/sendmoneyservice';
import { UserStateService } from '../../../../_services/userservice/userstateservice';
import { TransactionHistoryService } from '../../../../_services/transaction/transaction-history.service';
import { geolocation } from '../../../../sharedcomponents/commonservice/geolocation/geoloc';
import { debug } from 'util';
import { ShopingCart } from 'app/models/dashboard/cart/mywallet.currentcart.Modal';

export class CustomModalContext extends BSModalContext {
  public isMobileScreen: boolean;
}
@Component({
  selector: 'app-payment-receipt-debitcard-individual-popup',
  templateUrl: './payment-receipt-debitcard-individual-popup.component.html',
  styleUrls: ['./payment-receipt-debitcard-individual-popup.component.css'],
  providers: []
})
//ModalComponent<receiptModalContext>,
export class PaymentReceiptDebitcardindividualPopupComponent implements ModalComponent<CustomModalContext>, OnInit {
  context: CustomModalContext;

  receiptData: any = {};
  agentImgData: any = {};
  userDetail: any = '';
  branchImageData = '';
  currencyCodeSourceCountry;
  currencyCodedestCountry;
  public isMobileScreen = false;

  customerCareNumber;
  img: any = {};
  openingShareCredit = 0;
  ShareCreditonthisTranscation = 0;
  balanceShareCredit = 0;
  totalAmountPaidbyUser = 0;
  localAmount = 0;
  disclaimers = '';
  OrderList = [];
  OrderStatusList: any = {};
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private paymentreceipt: PaymentreceiptService,
    public utilserv: utilityService,
    private router: Router,
    public smService: SendMoneyService,
    private userStateService: UserStateService,
    private transactionHistoryService: TransactionHistoryService,
    public geoloc: geolocation // public dialog: DialogRef<ReceiptModalContext>
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });

    this.context = dialog.context;
    // this.context = dialog.context;
    //  this.isMobileScreen = dialog.context.isMobileScreen;
    if (window.screen.width < Number(AppSettings.MOBILE_SCREEN_WIDTH)) {
      this.isMobileScreen = true;
    }
    const CountryObject = this.geoloc.getCountryObject();
    this.customerCareNumber = this.utilserv.getCustomerCarePhone(CountryObject);
  }
  calculateShareCredit(receiptData) {
    this.localAmount = Number(this.utilserv.getObjectText(receiptData[0].AmountLocal)); // its not total amount, it is local amount
    const totAmount = Number(this.utilserv.getObjectText(receiptData[0].TotalAmount));
    const fee = Number(this.utilserv.getObjectText(receiptData[0].AmountLocal));
    const shareCredit = Number(this.utilserv.getObjectText(receiptData[0].MarketingBalance));
    if (totAmount >= shareCredit) {
      this.balanceShareCredit = 0;
      this.totalAmountPaidbyUser = totAmount - shareCredit;
    } else {
      this.totalAmountPaidbyUser = 0;
      this.balanceShareCredit = shareCredit - totAmount;
    }
  }
  ngOnInit() {
    // let x =this.dialog;

    const callSetStore = this.paymentreceipt.geIndivisualtRepeatorderData().subscribe(data => {
      this.receiptData = this.utilserv.getArray(data);
      this.calculateShareCredit(this.receiptData);

      this.currencyCodeSourceCountry = this.utilserv.getObjectText(data.CurrencyCodeFrom);
      this.currencyCodedestCountry = this.utilserv.getObjectText(data.CurrencyCodeTo); // this.utilserv.getObjectText(data.CountryCodeTo);
      // if (callSetStore !== undefined) {
      //   callSetStore.unsubscribe();
      // }
      // Branch Image

      const branchDetail: any = {};
      branchDetail.PayingAgentId = this.utilserv.getObjectText(this.receiptData[0].PayingAgentId);
      branchDetail.LocationId = this.utilserv.getObjectText(this.receiptData[0].PayingAgentLocationId);

      this.OrderList = new Array<ShopingCart>();
      let item = this.utilserv.getObjectText(this.receiptData[0].ItemId);
      this.OrderList.push(item);
      this.getOrderStatus();
      if (branchDetail.PayingAgentId != '') {
        this.utilserv.busy = this.smService.getBranchImage(branchDetail).subscribe(
          data => {
            if (data.HasDefaultImage == true) {
              this.branchImageData = '';
            } else {
              this.branchImageData = 'data:image/gif;base64,' + data.BranchImageData;
            }
          },
          error => {
            //console.log('Unable to fetch Branch Image' + error);
          }
        );
      }
    });
    // User Data
    this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.userDetail = data;
    });
    // this.getDisclaimer();
  }

  getDisclaimer() {
    this.utilserv.busy = this.smService.getDisclaimerDetails().subscribe(
      data => {
        if (data.StateCode == enumStatusCodeList.SUCCESS) {
          let josnObj: any = data.CountriesDisclaimer;
          let contryObj = josnObj.filter(country => country.CountryCode === this.userDetail.CountryCode)[0].States;
          let disclaimerLines = contryObj.filter(state => state.StateCode === this.userDetail.StateCode)[0].Lines;
          this.disclaimers = disclaimerLines.map(line => line).join(' ');
        }
      },
      error => {
        //console.log('Unable to fetch DisclaimerDetails' + error);
      }
    );
  }

  getOrderStatus() {
    const _self = this;
    const refFun = function() {
      _self.transactionHistoryService.getOrderItemStatus(_self.OrderList).subscribe(
        data => {
          if (data.Envelope.Body.OrderStatusResponse.StatusCode == enumStatusCodeList.SUCCESS) {
            _self.OrderStatusList = _self.utilserv.getArray(data.Envelope.Body.OrderStatusResponse.OrdersStatus.CartOrderStatus)[0];
            if (_self.utilserv.getObjectText(_self.OrderStatusList.PIN) == '') {
              setTimeout(refFun, 5000);
            }
          }
        },
        error => {
          //console.log('Unable to getOrderStatus' + error);
        }
      );
    };
    refFun();
  }
  // getOrderStatusObj(item): any {
  //   return this.OrderStatusList.filter(function(element) {
  //     return this.utility.getObjectText(element.ItemId) == item;
  //   });
  // }
  closePopup() {
    try {
      this.dialog.close();
    } catch (error) {}
  }
}



// WEBPACK FOOTER //
// ./src/app/dash-board/shoppingcart/payment-receipt-debitcard/payment-receipt-debitcard-individual-popup/payment-receipt-debitcard-individual-popup.component.ts